import { useApp } from '../../context/AppContext';

const NAV_ITEMS = [
  { id: "home", label: "Home", icon: "🏠" },
  { id: "calculator", label: "Calculator", icon: "📊" },
  { id: "actions", label: "Actions", icon: "✅" },
  { id: "ai", label: "AI Coach", icon: "🤖" },
  { id: "share", label: "Share", icon: "📣" },
];

export function Navigation() {
  const { view, setView, userName, theme, toggleTheme } = useApp();

  return (
    <nav
      style={{
        position: "sticky",
        top: 0,
        zIndex: 100,
        background: "var(--bg-secondary)",
        backdropFilter: "blur(14px)",
        borderBottom: "1px solid var(--border-color)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0.7rem 1.2rem",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
        <span style={{ fontSize: "1.3rem" }} aria-hidden="true">🌍</span>
        <span style={{ color: "#4ade80", fontSize: "0.92rem", fontStyle: "italic" }}>
          GreenPlan{userName ? ` · ${userName}` : ""}
        </span>
      </div>
      <div style={{ display: "flex", gap: "0.4rem", alignItems: "center" }}>
        <button
          onClick={toggleTheme}
          style={{
            padding: "0.35rem 0.55rem",
            borderRadius: "8px",
            border: "1px solid var(--border-color)",
            background: "var(--bg-card)",
            color: "var(--text-secondary)",
            fontSize: "0.72rem",
            cursor: "pointer",
            transition: "all 0.2s",
          }}
          aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
          title={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
        >
          {theme === "dark" ? "☀️ Light" : "🌙 Dark"}
        </button>
        <div style={{ display: "flex", gap: "0.2rem" }} role="navigation" aria-label="Main navigation">
        {NAV_ITEMS.map(item => (
          <button
            key={item.id}
            onClick={() => setView(item.id)}
            aria-current={view === item.id ? "page" : undefined}
            style={{
              padding: "0.35rem 0.65rem",
              borderRadius: "8px",
              border: "none",
              background: view === item.id ? "rgba(34,197,94,0.18)" : "transparent",
              color: view === item.id ? "#4ade80" : "#6b7280",
              fontSize: "0.75rem",
              cursor: "pointer",
              transition: "all 0.2s",
            }}
          >
            <span aria-hidden="true">{item.icon}</span> {item.label}
          </button>
        ))}
        </div>
      </div>
    </nav>
  );
}
